import Alert from "@mui/material/Alert";
import MDButton from "components/MDButton";

type Props = {
  message: string;
  onRetry?: () => void;
};

export default function FinanceiroErrorState({ message, onRetry }: Props) {
  return (
    <Alert
      severity="error"
      action={
        onRetry ? (
          <MDButton color="dark" variant="outlined" size="small" onClick={onRetry}>
            Tentar novamente
          </MDButton>
        ) : null
      }
    >
      {message}
    </Alert>
  );
}
